import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
// import { useEffect } from "preact/hooks";
import SearchBanner from "./SearchBanner"
export default function NoResults() {
    // useEffect(() => {
    //     if(window.nostojs) {
    //         window.nostojs(api => {
    //            api
    //             .createRecommendationRequest({ includeTagging: true })
    //             .setElements(["noresults-nosto-1"])
    //             .load({ skipPageViews: true, skipEvents: true })
    //         })
    //     }
    // }, [])
    const addNoIndexMetaTag = () => {
      if (!document.querySelector('meta[name="robots"][content="noindex"]')) {
        const metaRobots = document.createElement("meta");
        metaRobots.name = "robots";
        metaRobots.content = "noindex";
        document.head.appendChild(metaRobots);
      }
    };
    // Call the function to add the meta tag
    addNoIndexMetaTag();
    const toggleLiveChat = (event) => {
        event.preventDefault();
        const liveChatiFrame = document.getElementById('chat-button');
        if(!liveChatiFrame) return;
        const liveChatDocument = liveChatiFrame.contentWindow.document;
        const liveChatBtn = liveChatDocument.querySelector('button[aria-label="Open gorgias live chat"]');
        if(liveChatBtn) {
            liveChatBtn.click();
        }
    }
    return (
        <>
            <SearchBanner />
            <div class="ns-top-categories">
                <div class="ns-top-categories-header">
                    <div class="ns-top-categories-eyebrow">Explore Our</div>
                    <h3 class="ns-top-categories-heading">Top Categories</h3>
                </div>
                <div class="ns-top-category-list">
                    {<div class="ns-top-category-item">
                        <a href="/collections/womens-footwear">
                            <div class="ns-top-category-img-wrap">
                                <img
                                    src="https://www.thefryecompany.com/cdn/shop/files/Heritage_Made_in_USA_Women_s_480_x_672_1000x@2x.jpg?v=1680554830"
                                    alt="Women's Footwear"
                                    width={500}
                                    height={500}
                                />
                            </div>
                            <div class="ns-top-category-name">Women's Boots</div>
                        </a>
                    </div>}
                    <div class="ns-top-category-item">
                        <a href="/collections/mens-footwear">
                            <div class="ns-top-category-img-wrap">
                                <img
                                    src="https://www.thefryecompany.com/cdn/shop/files/Heritage_Menu_The_Frye_Story_480_x_672_1000x@2x.jpg?v=1680554829"
                                    alt="Men's Footwear"
                                    width={500}
                                    height={500}
                                />
                            </div>
                            <div class="ns-top-category-name">Men's Boots</div>
                        </a>
                    </div>
                    <div class="ns-top-category-item">
                        <a href="/collections/sale">
                            <div class="ns-top-category-img-wrap">
                                <img
                                    src="https://www.thefryecompany.com/cdn/shop/files/Sale_Menu_Women_s_480_x_672_1000x@2x.jpg?v=1680554829"
                                    alt="Sale category"
                                    width={500}
                                    height={500}
                                />
                            </div>
                            <div class="ns-top-category-name">Sale</div>
                        </a>
                    </div>
                </div>
            </div>
            <div class="ns-help-container">
                <div class="ns-help-wrapper">
                    <h2 class="ns-help-header">Need help finding the right product for you?</h2>
                    <div class="ns-help-text">Reach out to our team for product advice, sizing help, or assitance.</div>
                    <div class="ns-help-btn-wrapper">
                        <button class="ns-toggle-live-chat" type="button" onClick={toggleLiveChat}>Live Chat</button>
                        <a class="ns-contact-us-link" href="/pages/contact">Contact Us</a>
                    </div>
                </div>
            </div>
        </>
    )
}